document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) toggle.addEventListener('click', () => mobileNav.classList.toggle('is-open'));

  const drawer = document.querySelector('[data-cart-drawer]');
  const openers = document.querySelectorAll('[data-open-cart]');
  const closers = document.querySelectorAll('[data-close-cart]');
  openers.forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); drawer?.classList.add('is-open'); }));
  closers.forEach(btn => btn.addEventListener('click', () => drawer?.classList.remove('is-open')));

  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      if (!drawer) return;
      e.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      submit?.setAttribute('disabled','disabled');
      try {
        await fetch('/cart/add.js', { method:'POST', headers:{'X-Requested-With':'XMLHttpRequest'}, body:new FormData(form) });
        window.location.href = '/cart';
      } catch(err) {
        console.error(err);
        form.submit();
      } finally { submit?.removeAttribute('disabled'); }
    });
  });
});
